import { render } from "./Calendar.vue?vue&type=template&id=8bf3c1d2"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=8bf3c1d2&lang=scss"

import exportComponent from "/home/nodeapps/vitamins/aaa/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__